import React, { useEffect } from "react";
import { View, ActivityIndicator } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";
import usePermission from "./hooks/usePermission";
import { DATUM_PAGE } from "./constants";
import { sharedStyles } from "./styles";

// Legacy entry-point — the Home screen now surfaces CP Routing + Item
// Packing as backend-driven SMALL_BOX widgets via the homepage widgets
// API (nav_to: 'CpRoutingScreen' / 'PackingDbListScreen'), so this
// route only fires from external deep links. We redirect to
// CpRoutingScreen on first render so the route name continues to
// resolve.

const PartnerRoutingAndPacking = ({ navigation }) => {
  const perm = usePermission(DATUM_PAGE.ROUTING);

  useEffect(() => {
    if (perm.isPending) return;
    if (perm.isAllowed) {
      navigation.replace("CpRoutingScreen");
    }
  }, [perm.isPending, perm.isAllowed, navigation]);

  if (perm.isPending) {
    return (
      <View style={sharedStyles.centered}>
        <ActivityIndicator color={color.mediumBlack} />
      </View>
    );
  }
  if (!perm.isAllowed) {
    return (
      <View style={sharedStyles.centered}>
        <Text variant="title_16" style={sharedStyles.permissionMsg}>
          You don&apos;t have permission to view this page
        </Text>
      </View>
    );
  }
  return (
    <View style={sharedStyles.centered}>
      <ActivityIndicator color={color.mediumBlack} />
    </View>
  );
};

export default PartnerRoutingAndPacking;
